import React from "react";
import { PersonSimpleWalk } from "@phosphor-icons/react";

const DEST = "ACCI Building, Hills Road, Cambridge CB2 0QQ";
const DIRECTIONS = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent("Cambridge South railway station")}&destination=${encodeURIComponent(DEST)}&travelmode=walking`;

export const CampusMap = () => (
  <div data-testid="campus-map" className="bg-white border border-stone-200/60 rounded-md overflow-hidden">
    <iframe title="Map of the clinic on the Cambridge Biomedical Campus" data-testid="campus-map-iframe"
      src={`https://www.google.com/maps?q=${encodeURIComponent(DEST)}&z=15&output=embed`}
      className="w-full h-64 border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
    <div className="p-5">
      <a href={DIRECTIONS} target="_blank" rel="noopener noreferrer" data-testid="campus-map-walking-link" className="btn-primary w-full justify-center inline-flex items-center gap-2">
        <PersonSimpleWalk size={18} weight="bold" /> Walking directions from Cambridge South
      </a>
      <p className="mt-2 text-xs text-ink-muted">Opens Google Maps with the walking route from the station to the clinic.</p>
    </div>
  </div>
);
